// 组件对象，大写
import crudArrayOrder from './crudArrayOrder.vue'
export default crudArrayOrder
